'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKeyPathOnChannel = getKeyPathOnChannel;
exports.getFilteredConversations = getFilteredConversations;
exports.findThreadIdWithChannel = findThreadIdWithChannel;

var _immutable = require('immutable');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _threadGetters = require('../thread/operators/threadGetters');

var _getLastActiveAt = require('../operators/conversation/getLastActiveAt');

var _getLastActiveAt2 = _interopRequireDefault(_getLastActiveAt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getKeyPathOnChannel(channel, path) {
  return [channel].concat(path);
}

function getFilteredConversations(conversations) {
  var channels = (0, _getIn2.default)(['threadList', 'channels'], conversations);

  if (!channels) return (0, _immutable.OrderedMap)();

  return channels.reduce(function (accumulator, channel) {
    return accumulator.set(channel, conversations.conversationsMap.get(channel));
  }, (0, _immutable.OrderedMap)()).sortBy(_getLastActiveAt2.default, function (t1, t2) {
    var now = Date.now();
    return (t2 || now) - (t1 || now);
  });
}

function findThreadIdWithChannel(conversations, channel) {
  var conversation = (0, _get2.default)(channel, conversations);

  return (0, _threadGetters.getThreadId)(conversation) || null;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/models/ConversationsModel.js
// module id = 873
// module chunks = 2 3